import React from 'react';
import { Loader2 } from 'lucide-react';
import { ChatMessage, ChatTypingIndicator } from './Message';
import { Message } from '../../types/chat';

interface ChatMessagesProps {
  messages: Message[];
  isTyping: boolean;
  messagesEndRef: React.RefObject<HTMLDivElement>;
}

const ChatMessages: React.FC<ChatMessagesProps> = React.memo(({ 
  messages, 
  isTyping, 
  messagesEndRef 
}) => {
  return (
    <div className="flex-1 overflow-y-auto p-4 space-y-4">
      {messages.map((message) => (
        <ChatMessage
          key={message.id}
          text={message.text}
          sender={message.sender}
          timestamp={message.timestamp}
        />
      ))}
      
      {isTyping && (
        <div className="flex justify-start">
          <ChatTypingIndicator />
        </div>
      )}
      
      <div ref={messagesEndRef} />
    </div>
  );
});

ChatMessages.displayName = 'ChatMessages';

export default ChatMessages;